<template>
    <div class="tw-w-full tw-h-full tw-p-4 tw-bg-cyan-500 tw-text-white tw-rounded-md">
        <h1>My Meetings</h1>
    </div>
</template>

<script setup>

</script>

<style scoped>
</style>